import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

export default function ConfirmRemoveMobileLocationModal({ onClose, onConfirm, mobileName }) {
  // Handle both old format (string) and new format (object with location_name)
  const displayName = typeof mobileName === 'object' && mobileName !== null
    ? mobileName.location_name
    : mobileName;

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box width={34} />
          <Typography fontSize={20} fontWeight={500} color="text.primary" align="center">
            Attention
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          This item is currently assigned to mobile location <b>{displayName}</b>. Would you like to
          remove that mobile location or keep it?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
        <Button onClick={onConfirm} variant="outlined">
          Remove Mobile Location
        </Button>
        <Button onClick={onClose} variant="contained" color="primary">
          Keep Mobile Location
        </Button>
      </DialogActions>
    </Dialog>
  );
}
